import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const nodule: AnswerPathTreeNode = {
  path: 'nodule',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredNoduleDetails }],
};
